import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteSubgroup = (parentGroupId, subGroupId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ADMIN.GROUP_MANAGEMENT.DELETE_SUBGROUP(
      parentGroupId,
      subGroupId
    )
  );
};

export default deleteSubgroup;
